import React from 'react';
import './style/Button.css';
import BaseTextLink from './BaseTextLink';

/**
 * Just a button, plus:
 *   - auto-sets type to "button"
 *   - uses pointer cursor when enabled
 * Accepts custom css classes
 *
 * Will render an inline-block link if you give it a to or href property.
 * (Helpful for styled buttons that need to support multiple modes of linking)
 */
export default function Button({
  children,
  type = 'button',
  className,
  dispatch,
  domRef,
  ...restProps
}) {
  const classes = ['Button'];
  if (restProps.to || restProps.href) {
    classes.push('Button--Link');
  }
  if (className) {
    classes.push(className);
  }

  if (restProps.to || restProps.href) {
    return (
      <BaseTextLink {...restProps} className={classes.join(' ')}>
        {children}
      </BaseTextLink>
    );
  }

  return (
    <button
      type={type}
      className={classes.join(' ')}
      {...restProps}
      ref={el => domRef && domRef(el)}
    >
      {children}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/Button.js